import { Model } from '@descomplica/dex-models';

export interface ReactionInfo {
  reaction: string;
  count: number;
  userReacted: boolean;
}

export class ContentReactions extends Model {
  contentId: string;

  source: string;

  reactions: ReactionInfo[];

  constructor(data: any, getters?: any) {
    super(getters);

    this.contentId = data.contentId;
    this.source = data.source;
    this.reactions = data.reactions;
  }
}
